import "./EliteProduction.css";
import React, { useState, useEffect, useMemo } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { appendProductionInstanceScope } from "../productionRequestScope";
// ❌ Removed global CSS imports that were leaking everywhere
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";

import axios from "axios";

import { Tabs, Tab } from "react-bootstrap"; // Using react-bootstrap
import classNames from "classnames";
import {
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
  Badge,
} from "reactstrap";

import {
  DndContext,
  pointerWithin,
  useSensors,
  useSensor,
  PointerSensor,
  KeyboardSensor,
  useDroppable,
  closestCorners,
  DragOverlay,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import BoardForm from "./partials/BoardForm";
import TaskForm from "./partials/TaskForm";
import InstanceLeftSidebartSidebar from "../../InstanceLeftSidebar";
import PageHeaderWithBreadcrumbs from "../../../../components/PageHeaderWithBreadcrumbs";
import { FaPlus, FaTrash, FaCalendar, FaEdit } from "react-icons/fa";

import ProductionTable from "./ProductionTable";
import { Container } from "react-bootstrap";
import EliteMachines from "./EliteMachines";
import EliteReports from "./EliteReports";
import ProductionTableAnt from "./ProductionTableAnt";

import EliteMachinesUI2 from "./EliteMachinesUI2";
import EliteMachinesTab from "./EliteMachinesTab";

// import { useState } from "react";
import { Offcanvas, Button } from "react-bootstrap";
import EliteKanbanBoard from "./elite_kanban_board";
import AvailableForPlanning from "../AvailableForPlanning";
import EliteKanbanBoard1 from "../elite_kanban_board1";

import { defaultDropAnimation } from "@dnd-kit/core";

import { Modal } from "react-bootstrap";
import EliteKanbanBoard2 from "../elite_kanban_board2";
import EliteKanbanBoardV2_6 from "../elite_kanban_board3";
import ProductionCalendar from "./ProductionCalendar";

import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import ProductionGantt from "./ProductionGantt";
import EliteProductionDashboard from "./EliteProductionDashboard";
import ProductionGanttMovement from "./ProductionGanttMovement";


/* ──────────────────────────────────────────────────────────────────────────────
   Scoped asset loader (inline): loads CSS/JS only while this component is mounted
   ────────────────────────────────────────────────────────────────────────────── */
function useEphemeralAsset(hrefOrSrc, kind = "css") {
  useEffect(() => {
    let el;
    if (kind === "css") {
      el = document.createElement("link");
      el.rel = "stylesheet";
      el.href = hrefOrSrc;
    } else {
      el = document.createElement("script");
      el.src = hrefOrSrc;
      el.defer = true;
    }
    document.head.appendChild(el);
    return () => {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
  }, [hrefOrSrc, kind]);
}

const list = [
  {
    id: "Open",
    title: "Upcoming",
    theme: "light",
    items: [
      {
        id: "task-1",
        title: "Convert Design to Web Template",
        desc: "Start implementing the new UI layout using frontend code.",
        meta: {
          users: [
            { value: "Sara Dervashi", label: "Sara Dervashi", theme: "light" },
          ],
          tags: [
            { value: "Design", label: "Design", theme: "info" },
            { value: "HTML", label: "HTML", theme: "danger" },
          ],
          date: "2 Jul 2025",
          category: "Frontend",
          comment: "2",
        },
      },
      {
        id: "task-2",
        title: "Teemers",
        desc: "Start implementing the new UI layout using frontend code.",
        meta: {
          users: [
            { value: "Cooper Jones", label: "Cooper Jones", theme: "blue" },
          ],
          tags: [
            { value: "Design", label: "Design", theme: "info" },
            { value: "React", label: "React", theme: "dark" },
          ],
          date: "2 Jul 2025",
          category: "Frontend",
          comment: "5",
          attachment: "3",
        },
      },
    ],
  },
  {
    id: "InProgress",
    title: "Scheduled",
    theme: "primary",
    items: [
      {
        id: "task-3",
        title: "Teemers",
        desc: "Start implementing the new UI layout using frontend code.",
        board: "In Progress",
        meta: {
          users: [
            {
              value: "Ashraf Raneem",
              label: "Ashraf Raneem",
              theme: "primary",
            },
          ],
          tags: [
            { value: "Design", label: "Design", theme: "info" },
            { value: "UI Design", label: "UI Design", theme: "warning" },
          ],
          due: "2",
          category: "Design",
          comment: "4",
          attachment: "1",
        },
      },
      {
        id: "task-4",
        title: "Teemers",
        desc: "Start implementing the new UI layout using frontend code.",
        board: "In Progress",
        meta: {
          users: [
            {
              value: "Vernon Hollander",
              label: "Vernon Hollander",
              theme: "danger",
            },
          ],
          tags: [
            { value: "Design", label: "Design", theme: "dark" },
            { value: "SEO", label: "SEO", theme: "success" },
          ],
          date: "2 Jul 2025",
          category: "Research",
          comment: "21",
          attachment: "31",
        },
      },
      {
        id: "task-5",
        title: "Teemers",
        desc: "Start implementing the new UI layout using frontend code.",
        board: "In Progress",
        meta: {
          users: [
            { value: "Patrick Newman", label: "Patrick Newman", theme: "pink" },
          ],
          tags: [
            { value: "Design", label: "Design", theme: "primary" },
            { value: "UI Design", label: "UI Design", theme: "warning" },
          ],
          due: "8",
          category: "Design",
          comment: "5",
          attachment: "1",
        },
      },
      {
        id: "task-6",
        title: "Teemers",
        desc: "Start implementing the new UI layout using frontend code.",
        board: "In Progress",
        meta: {
          users: [
            { value: "Jose Fayman", label: "Jose Fayman", theme: "purple" },
            { value: "Indever Clay", label: "Indever City", theme: "success" },
          ],
          tags: [
            { value: "Redesign", label: "Redesign", theme: "light" },
            { value: "UI Design", label: "UI Design", theme: "warning" },
          ],
          date: "2 Jul 2025",
          category: "Design",
          comment: "15",
          attachment: "19",
        },
      },
    ],
  },
  {
    id: "ToReview",
    title: "In Production",
    theme: "warning",
    items: [
      {
        id: "task-7",
        title: "Teemers",
        desc: "Start implementing the new UI layout using frontend code.",
        board: "In Progress",
        meta: {
          users: [
            { value: "Jose Fayman", label: "Jose Fayman", theme: "purple" },
          ],
          tags: [
            { value: "Web", label: "Web", theme: "success" },
            { value: "Android", label: "Android", theme: "light" },
          ],
          date: "2 Jul 2025",
          category: "Design",
          comment: "50",
          attachment: "11",
        },
      },
      {
        id: "task-8",
        title: "Teemers",
        desc: "Start implementing the new UI layout using frontend code.",
        board: "To Review",
        meta: {
          users: [
            { value: "Ober Mayers", label: "Ober Mayers", theme: "purple" },
            {
              value: "Sergei Surnama",
              label: "Sergei Surnama",
              theme: "success",
            },
          ],
          tags: [
            { value: "UX", label: "UX", theme: "info" },
            { value: "Development", label: "Development", theme: "danger" },
          ],
          due: "1",
          category: "Backend",
          comment: "9",
          attachment: "1",
        },
      },
      {
        id: "task-9",
        title: "Teemers",
        desc: "Start implementing the new UI layout using frontend code.",
        board: "To Review",
        meta: {
          users: [
            {
              value: "Jermaine Klaus",
              label: "Jermaine Klaus",
              theme: "purple",
            },
            {
              value: "Sergei Surnama",
              label: "Sergei Surnama",
              theme: "success",
            },
          ],
          tags: [
            { value: "Web", label: "Web", theme: "dark" },
            { value: "IOS", label: "IOS", theme: "light" },
          ],
          due: "4",
          category: "Frontend",
          comment: "8",
          attachment: "5",
        },
      },
    ],
  },
  {
    id: "Completed",
    title: "QC",
    theme: "success",
    items: [],
  },
  {
    id: "Completed1",
    title: "Completed",
    theme: "success",
    items: [],
  },
];

function findUpper(name = "") {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();
}

const Column = ({ id, className, children }) => {
  const { setNodeRef } = useDroppable({
    id: id,
  });
  return (
    <main
      className={className && className}
      ref={setNodeRef}
      style={{
        minHeight: "200px",
        padding: "10px",
      }}
    >
      {children}
    </main>
  );
};
const Item = ({ item, children, className }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: item.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: isDragging
      ? "transform 0.25s ease, box-shadow 0.2s ease"
      : "transform 0.25s ease",
    zIndex: isDragging ? 999 : "auto",
    position: isDragging ? "absolute" : "relative",
    background: "#fff",
    boxShadow: isDragging
      ? "0 15px 25px rgba(0,0,0,0.2)"
      : "0 2px 6px rgba(0,0,0,0.1)",
    opacity: isDragging ? 0 : 1,
    borderRadius: "0.5rem",
    cursor: "move",
    pointerEvents: isDragging ? "none" : "auto",
    willChange: "transform",
  };

  return (
    <div
      className={className && className}
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={style}
    >
      {children}
    </div>
  );
};

const EliteProduction = () => {
  /* ─────────────────────────────────────────────────────────────
     Load Bootstrap ONLY while this component is mounted
     (removes <link>/<script> tags on unmount)
     ───────────────────────────────────────────────────────────── */
  useEphemeralAsset(
    "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css",
    "css"
  );
  useEphemeralAsset(
    "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css",
    "css"
  );
  // (Optional) If you use Bootstrap’s JS features (collapse, dropdown, modal toggles)
  useEphemeralAsset(
    "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js",
    "js"
  );

  const [smBtn, setSmBtn] = useState(false);
  const [addBoardModal, setAddBoardModal] = useState(false);
  const [editBoardModal, setEditBoardModal] = useState(false);
  const [addTaskModal, setAddTaskModal] = useState(false);
  const [editTaskModal, setEditTaskModal] = useState(false);

  const [columns, setColumns] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  const openModalOrOffcanvas = (task, fromCol, toCol) => {
    setSelectedTask({ ...task, fromCol, toCol });
    setShowModal(true);
  };

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const openOffcanvas = (task, fromCol, toCol) => {
    setSelectedTask({ ...task, fromCol, toCol });
    setShowOffcanvas(true);
  };

  const openModal = (task, fromCol, toCol) => {
    setSelectedTask({ ...task, fromCol, toCol });
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = (task) => {
    setSelectedTask(task);
    setShowModal(true);
  };

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 10 } }),
    useSensor(KeyboardSensor)
  );

  const findItem = (id) => {
    for (const col of columns) {
      const match = col.items.find((i) => i.id === id);
      if (match) return match;
    }
    return null;
  };

  const activeItem = useMemo(() => findItem(activeId), [activeId, columns]);

  const findColumn = (unique) => {
    if (!unique) {
      return null;
    }

    if (columns.some((c) => c.id === unique)) {
      return columns.find((c) => c.id === unique) ?? null;
    }
    const id = String(unique);
    const itemWithColumnId = columns.flatMap((c) => {
      const columnId = c.id;
      return c.items.map((i) => ({ itemId: i.id, columnId: columnId }));
    });
    const columnId = itemWithColumnId.find((i) => i.itemId === id)?.columnId;
    return columns.find((c) => c.id === columnId) ?? null;
  };

  const dropAnimation = {
    ...defaultDropAnimation,
    duration: 250,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await axios.get(
          appendProductionInstanceScope(`${process.env.REACT_APP_NODEJS_SERVER_URL}/production/orders?page=1&pageSize=50`, {
            pathname: window.location.pathname,
            apiBase: process.env.REACT_APP_NODEJS_SERVER_URL,
          }),
          { headers: { accessToken: localStorage.getItem("accessToken") || "" } }
        );

        if (res.data.success) {
          const apiItems = res.data.data.flatMap((order) =>
            order.items
              .filter((item) => item.decorations?.length > 0)
              .map((item) => ({
                id: `order-${order.orderNumber}-item-${item.itemId}`,
                title: `${order.customerName} (${order.orderNumber})`,
                desc: `${item.productName} — Qty: ${item.quantity}`,
                meta: {
                  users: [
                    {
                      value: order.customerName,
                      label: order.customerName,
                      theme: "primary",
                    },
                  ],
                  tags: item.decorations.map((dec) => ({
                    value: dec.chargeName,
                    label: dec.chargeName,
                    theme: "info",
                  })),
                  date: new Date(order.inHandsDate).toLocaleDateString(),
                  category: "Production",
                  comment: String(item.decorations.length),
                },
              }))
          );

          setColumns([
            { id: "Open", title: "Upcoming", theme: "light", items: apiItems },
            {
              id: "InProgress",
              title: "Scheduled",
              theme: "primary",
              items: [],
            },
            {
              id: "ToReview",
              title: "In Production",
              theme: "warning",
              items: [],
            },
            { id: "Completed", title: "QC", theme: "success", items: [] },
            {
              id: "Completed1",
              title: "Completed",
              theme: "success",
              items: [],
            },
          ]);
        }
      } catch (err) {
        console.error("Error fetching orders:", err);
      }
    };

    // fetchOrders();
  }, []);

  const handleDragOver = (event) => {
    const { active, over, delta } = event;
    if (!over || !over.id) return;

    const activeId = String(active.id);
    const overId = String(over.id);

    const activeColumn = findColumn(activeId);
    const overColumn = findColumn(overId);

    if (!activeColumn || !overColumn || activeColumn.id === overColumn.id)
      return;

    const activeItemIndex = activeColumn.items.findIndex(
      (i) => i.id === activeId
    );
    const overItemIndex = overColumn.items.findIndex((i) => i.id === overId);

    const draggedItem = activeColumn.items[activeItemIndex];
    const newActiveItems = [...activeColumn.items];
    newActiveItems.splice(activeItemIndex, 1);

    const newIndex = () => {
      const placingAtEnd =
        overItemIndex === -1 ||
        (overItemIndex === overColumn.items.length - 1 && delta.y > 0);
      return placingAtEnd ? overColumn.items.length : overItemIndex;
    };

    const newOverItems = [...overColumn.items];
    newOverItems.splice(newIndex(), 0, draggedItem);

    setColumns((prevColumns) =>
      prevColumns.map((col) => {
        if (col.id === activeColumn.id) {
          return { ...col, items: newActiveItems };
        }
        if (col.id === overColumn.id) {
          return { ...col, items: newOverItems };
        }
        return col;
      })
    );
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return;

    const activeId = String(active.id);
    const overId = String(over.id);

    const fromCol = findColumn(activeId);
    const toCol = findColumn(overId);
    if (!fromCol || !toCol) return;

    if (fromCol.id === toCol.id) {
      const oldIndex = fromCol.items.findIndex((i) => i.id === activeId);
      const newIndex = toCol.items.findIndex((i) => i.id === overId);
      if (oldIndex === -1 || newIndex === -1 || oldIndex === newIndex) return;

      setColumns((prev) =>
        prev.map((c) =>
          c.id === fromCol.id
            ? { ...c, items: arrayMove(c.items, oldIndex, newIndex) }
            : c
        )
      );
      return;
    }

    const fromIndex = fromCol.items.findIndex((i) => i.id === activeId);
    if (fromIndex === -1) return;

    const fromColIndex = columns.findIndex((c) => c.id === fromCol.id);
    const toColIndex = columns.findIndex((c) => c.id === toCol.id);

    if (toColIndex !== fromColIndex + 1) {
      console.warn("Invalid move! Must follow sequential order.");
      return;
    }

    const overIndex = toCol.items.findIndex((i) => i.id === overId);

    setColumns((prev) =>
      prev.map((c) => {
        if (c.id === fromCol.id) {
          const next = [...c.items];
          next.splice(fromIndex, 1);
          return { ...c, items: next };
        }
        if (c.id === toCol.id) {
          const next = [...c.items];
          const insertAt = overIndex === -1 ? next.length : overIndex;
          next.splice(insertAt, 0, fromCol.items[fromIndex]);
          return { ...c, items: next };
        }
        return c;
      })
    );

    const movedItem = fromCol.items[fromIndex];
    openOffcanvas(movedItem, fromCol, toCol);
  };

  if (typeof window !== "undefined") {
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserverOverride extends OriginalResizeObserver {
      constructor(callback) {
        super((entries) => {
          try {
            callback(entries);
          } catch (err) {
            if (!err.message.includes("ResizeObserver loop")) {
              throw err;
            }
          }
        });
      }
    };
  }

  const { instanceUniqueId, department, tabType } = useParams();
  const history = useHistory();
  const location = useLocation();

  const pathParts = location.pathname.split("/");

  const NON_DEPARTMENT_ROUTES = new Set(["all", "production"]);
  const isNonDepartmentRoute = NON_DEPARTMENT_ROUTES.has(department);

  // Convert hyphens ("-") to spaces (" "), except aggregate routes
  const formattedDepartment = isNonDepartmentRoute
    ? ""
    : department
      ? department.replace(/-/g, " ")
      : "";

  const [activeTab, setActiveTab] = useState("Kanban View");

  const handleTabChange = (tab) => {
    const tabMapping = {
      "Kanban View": "kanban",
       "Calendar View": "calendar",
       "Gantt View": "gantt",
       dashboard: "dashboard",
      "Table View": "table",
      Machines: "machines",
      Reports: "reports",
      Departments: "departments",
    };

    const tabSlug = tabMapping[tab] || "kanban";
    history.push(
      `/instance/${instanceUniqueId}/production/${department}/${tabSlug}`
    );
  };

  useEffect(() => {
    const tabMapping = {
      kanban: "Kanban View",
      calendar: "Calendar View",
      gantt: "Gantt View",
      dashboard: "dashboard",
      table: "Table View",
      machines: "Machines",
      reports: "Reports",
      departments: "Departments",
    };

    const activeTabFromRoute =
      tabMapping[tabType?.toLowerCase()] || "Kanban View";
    setActiveTab(activeTabFromRoute);
  }, [tabType]);

  useEffect(() => {
    console.log("Current Department:", department);
  }, [department]);

  // logging to confirm formatted output
  useEffect(() => {
    console.log("Original Department:", department);
    console.log("Formatted Department:", formattedDepartment);
  }, [department]);

  const departmentlabels = {
    all: "All Production",
    production: "All Production",
    embroidery: "Embroidery",
    "direct-to-film": "Direct To Film",
    cresting: "Cresting",
    engraving: "Engraving",
    screening: "Screening",
    awards: "Awards",
  };

  const pageTitle = departmentlabels[department] || "Production";

  return (
    <>
      <div className="instance-dashboard production-module">
        <InstanceLeftSidebar />
        <div className="rightSide">
          <div className="options-container fade-in-effect-usability">
            <div className="options-inner-container">
              <PageHeaderWithBreadcrumbs
                title={`Elite Decorations - ${pageTitle}`}
                breadcrumb={`Elite Decorations - ${pageTitle}`}
                includeButton={false}
              />
              <div title="Kanban Board"></div>
              <Container fluid>
                <Tabs
                  mountOnEnter
                  unmountOnExit
                  activeKey={activeTab}
                  onSelect={(k) => handleTabChange(k)}
                >
                  <Tab eventKey="Kanban View" title="Board View">
                    <AvailableForPlanning
                      // department={department}
                      department={formattedDepartment}
                    />
                  </Tab>
                  {/* <Tab eventKey="Table View" title="Table View">
                    <ProductionTable
                      // department={department}
                      department={formattedDepartment}
                    />
                  </Tab> */}
                  <Tab eventKey="Machines" title="Machines">
                    <EliteMachinesTab
                      // department={department}
                      department={formattedDepartment}
                    />
                  </Tab>

                  <Tab eventKey="Calendar View" title="Calendar View">
  <ProductionCalendar department={formattedDepartment} />
</Tab>

 <Tab eventKey="Gantt View" title="Gantt Timeline">
    {/* <ProductionGantt department={department} /> */}
{/* <div className="mt-5"></div> */}
{/* <hr className="my-5" /> */}
     <ProductionGanttMovement department={formattedDepartment} />
  </Tab>

  <Tab eventKey="dashboard" title="Dashboard">
  <EliteProductionDashboard department={formattedDepartment} />
</Tab>


                  {/* <Tab eventKey="Reports" title="Reports">
                    <EliteReports />
                  </Tab> */}
                </Tabs>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EliteProduction;
